module.exports = __webpack_public_path__ + "img/search_poi_n.07fa464.png";